var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',{staticClass:"otro-blockquote is-size-5"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('span',[_vm._v(_vm._s(_vm.author))])])])}
var staticRenderFns = []

export { render, staticRenderFns }